import classNames from 'classnames/bind';
import styles from './Header.module.css';
import Select from '../../Select';
import { selectUserType } from '../../../features/authSlice';
import { useAppSelector } from '../../../hooks/useRedux';
import { ALL, GROUP } from '../../../constants';
import { isMobile } from '../../../utils/util';
import { Group } from '../../../types/common';

interface HeaderProps {
  title: string;
  groupList?: string[] | Group[];
  selectedGroup?: string;
  onGroupChange?: (groupName: string, groupIndex: number) => void;
  children?: React.ReactNode;
}

function isGroupObjectArray(list: unknown): list is Group[] {
  return (
    Array.isArray(list) &&
    list.length > 0 &&
    typeof list[0] === 'object' &&
    list[0] !== null &&
    'groupNm' in list[0]
  );
}

export default function Header({
  title,
  groupList,
  selectedGroup,
  onGroupChange,
  children,
}: HeaderProps) {
  const cx = classNames.bind(styles);
  const userType = useAppSelector(selectUserType);

  const formattedGroupList = groupList
    ? isGroupObjectArray(groupList)
      ? groupList.map((group) => group.groupNm)
      : groupList
    : [];

  const isShowGroupFilter =
    userType === 1 && formattedGroupList && formattedGroupList.length > 0;

  const handleGroupChange = (value: string, i: number) => {
    onGroupChange?.(value, i);
  };

  return (
    <div className={cx('activity-header')}>
      <h2
        className={cx('title')}
        dangerouslySetInnerHTML={{ __html: title }}
      ></h2>
      {(isShowGroupFilter || children) && (
        <div className={cx('activity-filter')}>
          {isShowGroupFilter && (
            <div className={cx('current-filter')}>
              {GROUP} :
              <Select
                name="group"
                list={[ALL, ...formattedGroupList]}
                value={selectedGroup || ALL}
                onClick={handleGroupChange}
                pos={
                  isMobile || isGroupObjectArray(groupList) ? 'left' : 'right'
                }
              />
            </div>
          )}
          {children}
        </div>
      )}
    </div>
  );
}
